import { Injectable } from '@angular/core';
import {Router} from "@angular/router";
import { UsersService } from '../users.service';
import { TokenStore } from '../../app/core/auth/token-store';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(private UsersService: UsersService, private router: Router) { }


  /**
   * Superuser check for the guards (2026-10-24). Always resolves - the old
   * version never resolved for a non-admin (or on an error), hanging the
   * navigation. A non-admin is signed out and sent to /login.
   */
  async IsAdminLogin(): Promise<boolean> {
    if (!this.IsLoggedIn()) {
      this.router.navigate(['/login']);
      return false;
    }
    const admin = await this.UsersService.verifyAdmin();
    if (!admin) {
      this.UsersService.signOut();
      this.router.navigate(['/login'], { queryParams: { reason: 'admin-only' } });
      return false;
    }
    return true;
  }

  isSuperUser(): boolean{
    return localStorage.getItem('is_superuser') == 'true';
  }
  // JWT-only: this used to check the legacy DRF token in localStorage.
  // Now that login no longer writes one, this gated every route behind
  // AuthGuard/AuthAdminGuard would have failed immediately after signing
  // in. TokenStore.isLoggedIn() is the JWT-era equivalent - true once
  // UsersService.auth() has stored an access token this page load, or
  // (after a reload) once restoreSession()'s silent refresh has run.
  IsLoggedIn(){
    return TokenStore.isLoggedIn()
  }
}
